import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { AbsolutePopup, PopPaper, TPopupVertical } from 'core-components/library/popup'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import { AttachmentsForDownload } from './components/attachmentsForDownload/AttachmentsForDownload'

import styles from './DownloadDocumentAttachments.module.scss'

interface IProps {
  documentEntryId: number
}

export const DownloadDocumentAttachments = ({ documentEntryId }: IProps) => {
  return (
    <div className={styles.root}>
      <AbsolutePopup
        verticalStartPosition={TPopupVertical.Bottom}
        popupContent={() => {
          return (
            <PopPaper className={styles.listWrapper}>
              <div className={styles.title}>
                <Translation text={TRANSLATION_KEYS.downloadAllAttachments.title} />
              </div>
              <AttachmentsForDownload documentEntryId={documentEntryId} />
            </PopPaper>
          )
        }}
      >
        <div className={styles.valueContainer}>
          <Button className={styles.action} variant="text">
            <i className="kbase kbase-download" />
          </Button>
        </div>
      </AbsolutePopup>
    </div>
  )
}
